var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_246_3487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 5L11.9499 8.33333H6.66659C4.83325 8.33333 3.33325 9.83333 3.33325 11.6667V31.6667C3.33325 33.5 4.83325 35 6.66659 35H33.3333C35.1666 35 36.6666 33.5 36.6666 31.6667V11.6667C36.6666 9.83333 35.1666 8.33333 33.3333 8.33333H28.0499L24.9999 5H14.9999ZM19.9999 30C15.3999 30 11.6666 26.2667 11.6666 21.6667C11.6666 17.0667 15.3999 13.3333 19.9999 13.3333C24.5999 13.3333 28.3333 17.0667 28.3333 21.6667C28.3333 26.2667 24.5999 30 19.9999 30Z",
    fill: "#31B680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 28.3333L22.0833 23.75L26.6666 21.6667L22.0833 19.5833L19.9999 15L17.9166 19.5833L13.3333 21.6667L17.9166 23.75L19.9999 28.3333Z",
    fill: "#31B680"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_246_3487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.08c336ae545f0705ff47a6c75c0ebed2.svg";
export { ForwardRef as ReactComponent };